import { render, staticRenderFns } from "./Assess.vue?vue&type=template&id=869c4e6e&scoped=true"
import script from "./Assess.vue?vue&type=script&lang=js"
export * from "./Assess.vue?vue&type=script&lang=js"
import style0 from "./Assess.vue?vue&type=style&index=0&id=869c4e6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869c4e6e",
  null
  
)

export default component.exports